import axios from "axios";
import { BASE_URL } from "../../config";
import { URL_API_GET_TIPE_PINJMAN } from "../../config/api";
import store from "../../redux";
import { SET_ERROR_STATE } from "../constants/actionTypes";

export const GetListTipePinjaman = (clientID, type, cb) => {
	const prefixResponse = "Gagal Mendapatkan Tipe Pinjaman";
	axios({
		method: "get",
		url: `${BASE_URL}${URL_API_GET_TIPE_PINJMAN(type)}`,
		headers: {
			"X-Client-ID": clientID,
			"Content-Type": "application/json",
		},
	})
		.then((res) => {
			const { data, status } = res;
			if (status !== 200) {
				store.dispatch({ type: SET_ERROR_STATE, payload: `${prefixResponse} : ${data.status.message}` });
			} else {
				const { products } = data.result;
				let list = [];
				products.forEach((data) => {
					list.push({
						text: data.productName,
						value: data.productUID,
					});
				});

				cb(list);
			}
		})
		.catch((err) => {
			const { data } = err.response;
			store.dispatch({ type: SET_ERROR_STATE, payload: `${prefixResponse} : ${data.status.message}` });
		});
};
